






































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListSubArea } from '@/components/config'

// services
import { SubAreaService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// models
import { SubAreaForm, SubAreaModel } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditSubArea from './modalCreateEdit.vue'

const newItem: SubAreaForm = {
  name: '',
  description: '',
  area_id: null,
  is_active: true,
  is_group_piecework: false
}

@Component({
  name: 'SubAreasIndex',
  components: {
    PageHeader,
    TableListSubArea,
    ModalCreateEditSubArea
  }
})
export default class SubAreasIndex extends Vue {
  showModal = false
  subArea: SubAreaForm = newItem
  title = 'Sub Areas'
  actionForm = 'save'
  idItemEdit: number|null = null
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'Sub Areas',
      active: true
    }
  ]

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.subArea = newItem
    this.showModal = true
  }

  editItem (item: SubAreaModel) {
    this.subArea = {
      name: item.name,
      area_id: item.area_id,
      description: item.description,
      is_active: item.is_active,
      is_group_piecework: item.is_group_piecework
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: SubAreaModel) {
    const msg = `Seguro que desea eliminar el Sub-Area: ${item.name}`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await SubAreaService.delete(item.id)
      alerts.success()
      this.tableList.getSubAreasWithPagination()
      loading('hide')
    }
  }

  async changeStatus (info: {id: number; status: boolean}) {
    loading('show')
    try {
      await SubAreaService.changeStatus(info.id, info.status)
      alerts.success()
      this.tableList.getSubAreasWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  get tableList (): Vue & { getSubAreasWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getSubAreasWithPagination: () => void }
  }

  get itemInit (): SubAreaForm {
    return newItem
  }
}
